<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>{{ title }}</h1>
      <v-row>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="3"
          offset-md="6"
          class="classPadding"
        >
          <v-text-field
            v-model="search"
            append-outer-icon="mdi-magnify"
            label="Search"
            class="classPadding"
            @click:append-outer="triggerSearch"
            @keyup.enter="triggerSearch"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="3" class="classPadding">
          <v-select
            :items="searchByItems"
            item-text="text"
            item-value="value"
            v-model="searchBy"
            class="classPadding"
          ></v-select>
        </v-col>
      </v-row>
      <v-data-table :items="items" :headers="headers" :loading="loading">
        <template v-slot:item.actions="{ item }">
          <v-btn icon text @click.prevent="select(item)">
            <v-icon>mdi-arrow-right-bold</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.approvedDate="{ item }">
          <span>{{ item.approvedDate | dateFormat }}</span>
        </template>
        <template v-slot:item.date="{ item }">
          <span>{{ item.date | dateFormat }}</span>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/empClearance";
export default {
  metaInfo: {
    title: "Employee Clearance Summary",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  data: () => ({
    title: "Employee Clearance Summary",
    classPadding: "my-0 py-0",
    items: [],
    headers: [
      { text: "", value: "actions", sortable: false },
      { text: "Transaction No.", value: "ecfNo" },
      { text: "Employee", value: "empName" },
      { text: "Created By", value: "createdByName" },
      { text: "Approver", value: "approverName" },
      { text: "Created Date", value: "date" },
      { text: "Approver Date", value: "approvedDate" },
      { text: "Order", value: "approverOrder" },
      { text: "Status", value: "status" }
    ],
    searchBy: null,
    search: null,
    searchByItems: [
      { text: "-- Select --", value: null },
      { text: "Transaction No.", value: "ecfNo" },
      { text: "Payroll Location", value: "locId" },
      { text: "Employee Name", value: "empName" },
      { text: "Status", value: "status" },
      { text: "Date Created", value: "dateCreated" },
      { text: "Created By", value: "createdBy" },
      { text: "Approver", value: "approverName" }
    ],
    loading: false
  }),
  methods: {
    triggerSearch() {
      this.loading = true;
      var data = {
        searchCategory: this.searchBy,
        searchValue: this.search
      };
      this.$axios
        .post(`${API_ENDPOINT}/summary`, data)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    select(item) {
      // eventBus.$emit("SELECTED_PRF_STATUS", item.status);
      this.$router.push(`/emp-clearance-summary/${item.ecfNo}`);
    }
  },
  created() {
    this.triggerSearch();

    this.getUserAccessRights("ECSUMMARY");
  }
};
</script>